import SchedulerExamDaySteps from "./SchedulerExamDaySteps";
import FormGridCell from "../common/FormGridCell";
import Grid from "@material-ui/core/Grid";
import React, { FC, useContext } from "react";
import Room from "@material-ui/icons/Room";
import TitleWithIcon from "../common/TitleWithIcon";
import Typography from "@material-ui/core/Typography";
import SchedulerTable from "./SchedulerTable";
import { SchedulerContextValue } from "./context/SchedulerContext";
import SchedulerButtons from "./SchedulerButtons";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  mainContainer: {
    overflow: "hidden",
    height: "calc(100vh - 88px)",
  },
  tableContainer: {
    overflow: "hidden",
    flex: 1,
  },
}));

const Scheduler: FC = () => {
  const classes = useStyles();
  const { examSessionLabel, selectedLocationName, selectedExamDayId, examDays, changeSelectedExamDay } =
    useContext(SchedulerContextValue);

  return (
    <Grid container direction="column" className={classes.mainContainer}>
      <Grid container>
        <Grid item={true} xs={12} sm={6}>
          <Typography variant="h6">{examSessionLabel}</Typography>
          <TitleWithIcon title={selectedLocationName} variant="h4">
            <Room />
          </TitleWithIcon>
        </Grid>
        <Grid item={true} xs={12} sm={6}>
          <SchedulerButtons />
        </Grid>

        <FormGridCell size="wide">
          <SchedulerExamDaySteps
            selectedExamDayId={selectedExamDayId}
            examDays={examDays}
            onExamDaySelected={changeSelectedExamDay}
          />
        </FormGridCell>
      </Grid>
      <Grid container={true} className={classes.tableContainer}>
        <SchedulerTable />
      </Grid>
    </Grid>
  );
};

export default Scheduler;
